module.exports = __webpack_public_path__ + "static/media/trafficOff.4ff95aa7.png";